import React from "react";

import { getColorClasses } from "@/features/products/utils";

interface ProductTypeIconProps {
  icon: React.ComponentType<any>;
  color: string;
}

export const ProductTypeIcon = ({
  icon: Icon,
  color,
}: ProductTypeIconProps) => {
  const { border, background, iconColor } = getColorClasses(color);
  return (
    <div
      className={`w-4.5 h-4.5 rounded-sm flex items-center justify-center border-0.5 ${border} ${background}`}
    >
      <Icon size={12} className={iconColor} />
    </div>
  );
};
